import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@mui/material';
import Layout from '~/components/Layout';
import { useLang } from '~/hooks/useLang';
import ListDeviceLogs from '../components/ListDeviceLogs';
import InternalHeader from '~/components/Layout/components/InternalHeader';
import InternalContent from '~/components/Layout/components/InternalContent';
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod';
import { useHookstate } from '@hookstate/core';
import notify from '~/utils/notify';
import { DeviceLogs } from '../interfaces';
import { searchDevicesLogs } from '../services';
import { LoadingButton } from '@mui/lab';
import FilterAutocompleteFetch from '~/components/FilterAutocompleteFetch';

export default function DeviceConnections() {
  const { translate } = useLang();
  const [deviceLogs, setDeviceLogs] = useState<readonly DeviceLogs[]>([]);
  const loading = useHookstate(false)
  const startDate = useHookstate<string | null>(null);
  const finishDate = useHookstate<string | null>(null);
  const deviceId = useHookstate<number | null | undefined>(null);
  const period = useHookstate('0')
  const resetValeus = useHookstate(false)
  const focusChange = useHookstate<boolean>(false)

  useEffect(() => {
    document.title = translate('Devices Connections - Dispatch System')
  }, [])

  const handleSearch = async () => {
    loading.set(true)
    if (!deviceId.get()) {
      loading.set(false)
      notify({ message: translate('Please enter a valid device'), type: 'error' })
      return;
    }
    if (!startDate.get() || !finishDate.get()) {
      loading.set(false)
      notify({ message: translate('Enter a start and end date'), type: 'error' })
      return;
    }
    const data = await searchDevicesLogs({
      deviceId: deviceId.get(),
      finishDate: finishDate.get(),
      startDate: startDate.get()
    }).finally(() => {
      loading.set(false)
    })
    setDeviceLogs(data);
  }

  const clearFilters = () => {
    deviceId.set(null)
    startDate.set(null)
    finishDate.set(null)
    period.set('0')
    resetValeus.set(!resetValeus.get())
    focusChange.set(false)
    setDeviceLogs([])
  }

  return (
    <Layout marginLayout={true}>
      <InternalHeader title={translate(`Device connections`)} />
      <InternalContent title={`${translate('Filters')}`} sxFont={{ fontWeight: 'bold', fontSize: 18 }}>
        <Grid container direction={'row'}>
          <Grid item xs={3} sx={{ padding: 1 }}>
            <FilterAutocompleteFetch
              label={'device'}
              urlFetch={'/device/find'}
              size={"small"}
              disabled={false}
              dataRequest="device"
              onFetchChange={(device: number | null) => deviceId.set(device)}
              resetValues={resetValeus.get()}
              resetValueNewProps={resetValeus.get()}
              focusChange={focusChange}
            />
          </Grid>
          <FilterSelectPeriod
            onStartDateChange={(value) => startDate.set(value?.toJSON() ?? null)}
            onFinishDateChange={(value) => finishDate.set(value?.toJSON() ?? null)}
            onPeriodChange={(value) => { period.set(value) }}
            period={period.get()}
          />
        </Grid>
        <Grid container direction={'row'} display={'flex'} justifyContent={'flex-end'} spacing={1}>
          <Grid item>
            <Button
              variant="outlined"
              onClick={clearFilters}
              sx={{ height: '40px' }}
            >
              {translate('Clear Filters')}
            </Button>
          </Grid>
          <Grid item>
            <LoadingButton
              loading={loading.get()}
              variant="contained"
              onClick={handleSearch}>
              {translate('Search')}
            </LoadingButton>
          </Grid>
        </Grid>
      </InternalContent>
      <InternalContent title={`${translate('Connections')}`} sxFont={{ fontWeight: 'bold', fontSize: 18 }}>
        <ListDeviceLogs devices={deviceLogs} />
      </InternalContent>
    </Layout>
  );
}
